////////LIBRARY/////////
import update from 'immutability-helper'
import { cloneDeep, find } from 'lodash'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const recapStock = {
	//region POST REQUESTS ...
	[ActionsTypes.POST_RECAP_STOCK_REQUEST]: (state) => {
		return update(state, {
			recapStock: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
			},
			columns: {
				currentDir: {
					$set: '',
				},
				currentColumn: {
					$set: '',
				},
			},
		})
	},
	[ActionsTypes.POST_RECAP_STOCK_SUCCESS]: (state, payload) => {
		const paging = {
			totalElements: payload.data.headerContent.contentPagined.totalElements,
			totalPages: payload.data.headerContent.contentPagined.totalPages,
		}

		return update(state, {
			recapStock: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				items: {
					$set: payload.data.headerContent.contentPagined.content,
				},
				paging: {
					$set: paging,
				},
				header: {
					$set: payload.data.headerParam.filters,
				},
				columnsTable: {
					$set: payload.data.headerParam.colums,
				},
			},
		})
	},
	[ActionsTypes.POST_RECAP_STOCK_FAILURE]: (state, payload) => {
		return update(state, {
			isLoading: {
				$set: false,
			},
			error: {
				$set: payload.error,
			},
		})
	},
	//endregion

	//region PUT REQUEST ...
	[ActionsTypes.PUT_RECAP_STOCK_REQUEST]: (state) => {
		return update(state, {
			recapStock: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.PUT_RECAP_STOCK_SUCCESS]: (state, payload) => {
		const stateRecap = cloneDeep(state.recapStock.items)

		payload.data.alertstockesDtos.forEach((elem, id) => {
			find(stateRecap, { itemkioskId: Number(elem.itemKioskId) })['alertStock'] = Number(elem.newAlertStock)
		})

		return update(state, {
			recapStock: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				items: {
					$set: stateRecap,
				},
			},
		})
	},
	[ActionsTypes.PUT_RECAP_STOCK_FAILURE]: (state, payload) => {
		return update(state, {
			recapStock: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		})
	},
	// endregion

	[ActionsTypes.POST_RECAP_STOCK_FROM_REDIRECT]: (state) => {
		return update(state, {
			recapStock: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.POST_RECAP_STOCK_FROM_REDIRECT_SUCCESS]: (state, payload) => {
		return update(state, {
			recapStock: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},

				header: {
					$set: payload.data,
				},
			},
		})
	},
	[ActionsTypes.POST_RECAP_STOCK_FROM_REDIRECT_FAILURE]: (state, payload) => {
		return update(state, {
			isLoading: {
				$set: false,
			},
			error: {
				$set: payload.error,
			},
		})
	},
	[ActionsTypes.RESET_RECAP_STOCK_FILTERS_INFOS]: (state, _payload) => {
		return update(state, {
			recapStock: {
				filtersInfos: {
					$set: {},
				},
			},
		})
	},
	[ActionsTypes.RESET_RECAP_STOCK]: (state, _payload) => {
		return update(state, {
			recapStock: {
				items: {
					$set: [],
				},
				paging: {
					$set: {},
				},
				header: {
					$set: {},
				},
				columnsTable: {
					$set: {},
				},
				filtersInfos: {
					$set: {},
				},
			},
		})
	},
}

export default recapStock
